<template>
  <div :class="[device_platform]" class="block-get get modal">
    <div class="blacking" @click="hideSelf"></div>
    <div class="get__container">
      <div class="get__body">
        <img
          v-if="device_platform !== 'mobile'"
          src="../images/utils/close.svg"
          alt="Закрыть"
          class="get__close"
          @click="hideSelf"
        />
        <img
          v-else
          src="../images/utils/close-black.svg"
          alt="Закрыть"
          class="get__close"
          @click="hideSelf"
        />
        <h3
          class="get__title font_type_block-title"
          v-html="data.title ? data.title : 'Заказать обратный звонок'"
        ></h3>
        <h4
          class="get__subtitle"
          v-html="
            data.subtitle
              ? data.subtitle
              : 'Заполните форму, и наш менеджер свяжется с вами'
          "
        ></h4>
        <callback-input
          v-on="$listeners"
          :form_class="'popup'"
          :focusOnMount="true"
          :data="data"
          button_theme="button_theme_black"
        >
          {{ data.button ? data.button : "Отправить заявку" }}
        </callback-input>
      </div>
    </div>
  </div>
</template>

<script>
import CallbackInput from "./callback-form/callback-input";
import Mixin from "../common/mixin";

export default {
  name: "full-get",
  components: { CallbackInput },
  mixins: [Mixin],
  props: ["data"],
  data() {
    return {
      phone: "",
    };
  },
  methods: {
    hideSelf() {
      this.$emit("close");
    },
    getAgreement() {
      this.$emit("getAgreement");
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

.get {
  width: 100%;
  display: flex;

  &__container {
    position: fixed;
    top: 50vh;
    left: 50vw;
    transform: translate(-50%, -50%);
    width: 100%;
    max-width: 95vw;
    display: flex;
    justify-content: center;
    z-index: 500;
    pointer-events: none;
  }

  &__title {
    font-family: "AudiTypeExt";
    font-size: 22px;
    line-height: 29px;
    text-align: center;
  }
  &__subtitle {
    font-size: 22px;
    line-height: 24px;
    font-size: 16px;
    font-weight: 400;
    margin: 20px 0 30px 0;
    text-align: center;
    color: #b3b3b3;
  }
  &__body {
    position: relative;
    max-width: 480px;
    padding: 40px 30px;
    background: #fff;
    pointer-events: all;
  }

  &__close {
    position: absolute;
    right: -20px;
    top: -25px;
    width: 14px;
    height: 14px;
    cursor: pointer;
  }
}

@media (max-width: $tablet-md) and (min-height: 550px) {
  .get {
    &__container {
      flex-direction: column;
      align-items: stretch;
      max-width: 400px;
    }
    &__body {
      max-width: 100%;
    }
  }
}
@media (max-width: $mobile-lg) {
  .get {
    &__container {
      top: 47vh;
      flex-direction: column;
      align-items: stretch;
      max-width: 400px;
    }
    &__body {
      max-width: 100%;
      padding: 25px 20px;
    }
    &__close {
      top: 10px;
      right: 10px;
    }

    &__title {
      font-size: 18px;
    }

    &__subtitle {
      font-size: 14px;
      margin: 10px 0 20px 0;
    }
  }
}

@media (max-width: $mobile-sm) {
  .get {
    &__container {
      max-width: calc(100vw - 16px);
    }
  }
}

@media (max-height: 550px) {
  .get {
    &__body {
      padding-right: 40px;
    }
    &__close {
      top: 12px;
      right: 10px;
    }
  }
}
</style>
